export default __webpack_public_path__ + "static/media/covid19.788ecd9e.png";